import { render } from "./App.vue?vue&type=template&id=a3982cfa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a3982cfa&scoped=true&lang=css"

import exportComponent from "/Users/mark/Documents/Coding-Projects/yor-hgc-2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3982cfa"]])

export default __exports__